import Http from '@/services/AdminHttp'

export default {
	async all () {
		try {
			const response = await Http.get('api/admin/users') 
			return response.data
		} catch (err) {
			throw err
		}
	},
	/**
	 * Get user by id
	 *
	 * @param {String} id uuid
	 * @return {Object} 
	 */
	async show (id) {
		try {
			const response = await Http.get(`api/admin/users/${id}`) 
			return response.data
		} catch (err) {
			throw err
		}
	},
	/**
	 * Create a new user
	 *
	 * @param {Object} 
	 * @return {Object} 
	 */
	async store (data) {
		try {
			const response = await Http.post('api/admin/users', data)
			return response.data
		} catch (err) {
			throw err
		}
	},
	/**
	 * Update user's data
	 *
	 * @param {String} id
	 * @param {Object} data
	 * @return {Object} 
	 */
	async update (id, data) {
		try {
			const response = await Http.patch(`api/admin/users/${id}`, data)
			return response.data
		} catch (err) {
			throw err
		}
	},

	/**
	 * Delete chosen user
	 *
	 * @param {String} id
	 */
	async delete (id) {
		try {
			return await Http.delete(`api/admin/users/${id}`)
		} catch (err) {
			throw err
		}
	}
}
